export const generateServerResponseErrorText = function (errors, entity) {
  var _entity$GeneralErrorM, _entity$GeneralErrorM2, _entity$FieldErrorMes;
  let correlationId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  const commonErrorText = 'Error';
  if (errors) {
    let errorText = '';
    // eslint-disable-next-line @typescript-eslint/no-loop-func
    for (const key in errors) if (errors.hasOwnProperty(key)) errors[key].forEach(err => errorText += err);
    return {
      title: commonErrorText,
      body: [errorText]
    };
  }
  if (!entity) {
    return {
      title: commonErrorText,
      body: [commonErrorText]
    };
  }
  const errorTitle = ((_entity$GeneralErrorM = entity.GeneralErrorMessage) !== null && _entity$GeneralErrorM !== void 0 ? _entity$GeneralErrorM : entity.generalErrorMessage) ? (_entity$GeneralErrorM2 = entity.GeneralErrorMessage) !== null && _entity$GeneralErrorM2 !== void 0 ? _entity$GeneralErrorM2 : entity.generalErrorMessage : commonErrorText;
  const fieldsErrors = (_entity$FieldErrorMes = entity.FieldErrorMessages) !== null && _entity$FieldErrorMes !== void 0 ? _entity$FieldErrorMes : entity.fieldErrorMessages;
  const fieldsErrorsArray = [];
  if (fieldsErrors === null) {
    return {
      title: commonErrorText,
      body: [errorTitle]
    };
  }
  for (const key in fieldsErrors) {
    if (fieldsErrors.hasOwnProperty(key)) {
      fieldsErrors[key].map(err => {
        var _err$Message, _err$Message2, _err$ErrorCode;
        fieldsErrorsArray.push(((_err$Message = err.Message) !== null && _err$Message !== void 0 ? _err$Message : err.message) ? (_err$Message2 = err.Message) !== null && _err$Message2 !== void 0 ? _err$Message2 : err.message : (_err$ErrorCode = err.ErrorCode) !== null && _err$ErrorCode !== void 0 ? _err$ErrorCode : err.errorCode);
      });
    }
  }
  if (correlationId) {
    fieldsErrorsArray.push("\n\nError code: ".concat(correlationId));
  }
  return {
    title: errorTitle,
    body: [fieldsErrorsArray]
  };
};